import { useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL || "https://woni.sklmb.co";

// Hardcoded credentials untuk halaman laporan
const LAPORAN_USER = {
  username: "admin@laporan.com",
  password: "123123"
};

function LaporanLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    setTimeout(() => {
      if (username === LAPORAN_USER.username && password === LAPORAN_USER.password) {
        localStorage.setItem("laporan_auth", "true");
        onLogin(true);
      } else {
        setError("Username atau password salah");
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(to bottom right, #0f172a, #1e293b)',display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
      <div style={{background:'white',borderRadius:'1rem',boxShadow:'0 25px 50px -12px rgba(0,0,0,0.25)',padding:'2rem',width:'100%',maxWidth:'28rem'}}>
        <div style={{textAlign:'center',marginBottom:'2rem'}}>
          <div style={{width:'4rem',height:'4rem',background:'linear-gradient(to bottom right, #fbbf24, #d97706)',borderRadius:'1rem',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 1rem',fontSize:'2rem'}}>📊</div>
          <h1 style={{fontSize:'1.5rem',fontWeight:'bold',color:'#1e293b'}}>Laporan Bulanan</h1>
          <p style={{color:'#64748b',fontSize:'0.875rem',marginTop:'0.25rem'}}>Wonderful Images Kemenpar</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{marginBottom:'1rem'}}>
            <label style={{display:'block',fontSize:'0.875rem',fontWeight:'500',color:'#374151',marginBottom:'0.5rem'}}>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{width:'100%',padding:'0.75rem 1rem',border:'1px solid #d1d5db',borderRadius:'0.75rem',outline:'none',boxSizing:'border-box'}}
              placeholder="admin@laporan.com"
              required
            />
          </div>

          <div style={{marginBottom:'1rem'}}>
            <label style={{display:'block',fontSize:'0.875rem',fontWeight:'500',color:'#374151',marginBottom:'0.5rem'}}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{width:'100%',padding:'0.75rem 1rem',border:'1px solid #d1d5db',borderRadius:'0.75rem',outline:'none',boxSizing:'border-box'}}
              placeholder="******"
              required
            />
          </div>

          {error && (
            <div style={{background:'#fef2f2',color:'#dc2626',padding:'0.75rem 1rem',borderRadius:'0.75rem',fontSize:'0.875rem',marginBottom:'1rem'}}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{width:'100%',background:'linear-gradient(to right, #f59e0b, #d97706)',color:'white',padding:'0.75rem',borderRadius:'0.75rem',fontWeight:'600',border:'none',cursor:loading?'not-allowed':'pointer',opacity:loading?0.5:1,display:'flex',alignItems:'center',justifyContent:'center',gap:'0.5rem'}}
          >
            {loading ? "Memverifikasi..." : "Masuk"}
          </button>
        </form>

        <div style={{marginTop:'1.5rem',textAlign:'center'}}>
          <a href="https://woni.sklmb.co" style={{fontSize:'0.875rem',color:'#64748b',textDecoration:'none'}}>
            ← Kembali ke Website
          </a>
        </div>
      </div>
    </div>
  );
}

function LaporanDashboard({ onLogout }) {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [downloading, setDownloading] = useState(false);

  const months = [
    { value: 1, label: "Januari" },
    { value: 2, label: "Februari" },
    { value: 3, label: "Maret" },
    { value: 4, label: "April" },
    { value: 5, label: "Mei" },
    { value: 6, label: "Juni" },
    { value: 7, label: "Juli" },
    { value: 8, label: "Agustus" },
    { value: 9, label: "September" },
    { value: 10, label: "Oktober" },
    { value: 11, label: "November" },
    { value: 12, label: "Desember" },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const handleDownloadReport = async () => {
    setDownloading(true);
    try {
      const monthName = months.find(m => m.value === selectedMonth).label;
      
      const loginRes = await fetch(API_URL + "/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: "admin@kemenpar.go.id", password: "Admin123!" })
      });
      
      if (!loginRes.ok) throw new Error("Gagal autentikasi");
      const { token } = await loginRes.json();

      const response = await fetch(
        API_URL + "/api/admin/reports/monthly?token=" + token + "&year=" + selectedYear + "&month=" + selectedMonth
      );
      
      if (!response.ok) throw new Error("Gagal generate laporan");
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Laporan_WonderfulImages_" + monthName + "_" + selectedYear + ".pdf";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      alert("Gagal generate laporan: " + err.message);
    } finally {
      setDownloading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("laporan_auth");
    onLogout();
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(to bottom right, #f8fafc, #f1f5f9)'}}>
      <header style={{background:'white',boxShadow:'0 1px 2px rgba(0,0,0,0.05)',borderBottom:'1px solid #e2e8f0'}}>
        <div style={{maxWidth:'56rem',margin:'0 auto',padding:'1rem 1.5rem',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <div style={{display:'flex',alignItems:'center',gap:'0.75rem'}}>
            <div style={{width:'2.5rem',height:'2.5rem',background:'linear-gradient(to bottom right, #fbbf24, #d97706)',borderRadius:'0.75rem',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.25rem'}}>📊</div>
            <div>
              <h1 style={{fontWeight:'bold',color:'#1e293b',margin:0}}>Laporan Bulanan</h1>
              <p style={{fontSize:'0.75rem',color:'#64748b',margin:0}}>Wonderful Images Kemenpar</p>
            </div>
          </div>
          <button onClick={handleLogout} style={{fontSize:'0.875rem',color:'#64748b',background:'none',border:'none',cursor:'pointer'}}>
            Logout →
          </button>
        </div>
      </header>

      <main style={{maxWidth:'56rem',margin:'0 auto',padding:'2.5rem 1.5rem'}}>
        <div style={{background:'white',borderRadius:'1rem',boxShadow:'0 10px 15px -3px rgba(0,0,0,0.1)',border:'1px solid #e2e8f0',padding:'2rem',marginBottom:'2rem'}}>
          <h2 style={{fontSize:'1.25rem',fontWeight:'bold',color:'#1e293b',marginBottom:'0.5rem'}}>Generate Laporan PDF</h2>
          <p style={{color:'#475569',marginBottom:'2rem'}}>
            Download laporan bulanan dalam format PDF profesional dengan charts, statistik, dan analisis AI.
          </p>

          <div style={{display:'flex',flexWrap:'wrap',alignItems:'flex-end',gap:'1rem'}}>
            <div>
              <label style={{display:'block',fontSize:'0.875rem',fontWeight:'500',color:'#374151',marginBottom:'0.5rem'}}>Bulan</label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                style={{padding:'0.75rem 1rem',border:'1px solid #d1d5db',borderRadius:'0.75rem',background:'white',minWidth:'150px'}}
              >
                {months.map((m) => (
                  <option key={m.value} value={m.value}>{m.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{display:'block',fontSize:'0.875rem',fontWeight:'500',color:'#374151',marginBottom:'0.5rem'}}>Tahun</label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                style={{padding:'0.75rem 1rem',border:'1px solid #d1d5db',borderRadius:'0.75rem',background:'white',minWidth:'120px'}}
              >
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>

            <button
              onClick={handleDownloadReport}
              disabled={downloading}
              style={{padding:'0.75rem 2rem',background:'linear-gradient(to right, #f59e0b, #d97706)',color:'white',borderRadius:'0.75rem',fontWeight:'600',boxShadow:'0 10px 15px -3px rgba(0,0,0,0.1)',border:'none',cursor:downloading?'not-allowed':'pointer',opacity:downloading?0.5:1,display:'flex',alignItems:'center',gap:'0.5rem'}}
            >
              {downloading ? "Generating..." : "📥 Download Laporan"}
            </button>
          </div>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(280px, 1fr))',gap:'1.5rem',marginBottom:'2rem'}}>
          <div style={{background:'linear-gradient(to bottom right, #eff6ff, #dbeafe)',borderRadius:'1rem',padding:'1.5rem',border:'1px solid #bfdbfe'}}>
            <h3 style={{fontWeight:'600',color:'#1e3a8a',marginBottom:'0.75rem'}}>📄 Isi Laporan</h3>
            <ul style={{fontSize:'0.875rem',color:'#1e40af',listStyle:'none',padding:0,margin:0}}>
              <li style={{marginBottom:'0.5rem'}}>✅ Cover page profesional dengan logo Kemenpar</li>
              <li style={{marginBottom:'0.5rem'}}>✅ Daftar Isi (Table of Contents)</li>
              <li style={{marginBottom:'0.5rem'}}>✅ Ringkasan Eksekutif (AI-generated)</li>
              <li style={{marginBottom:'0.5rem'}}>✅ Statistik utama dengan perbandingan</li>
              <li style={{marginBottom:'0.5rem'}}>✅ Top 10 artikel terpopuler</li>
              <li>✅ List artikel baru bulan ini</li>
            </ul>
          </div>

          <div style={{background:'linear-gradient(to bottom right, #faf5ff, #f3e8ff)',borderRadius:'1rem',padding:'1.5rem',border:'1px solid #d8b4fe'}}>
            <h3 style={{fontWeight:'600',color:'#581c87',marginBottom:'0.75rem'}}>📈 Visualisasi & Charts</h3>
            <ul style={{fontSize:'0.875rem',color:'#6b21a8',listStyle:'none',padding:0,margin:0}}>
              <li style={{marginBottom:'0.5rem'}}>📉 Line Chart - Trend artikel 6 bulan terakhir</li>
              <li style={{marginBottom:'0.5rem'}}>🥧 Pie Chart - Distribusi per kategori</li>
              <li style={{marginBottom:'0.5rem'}}>📊 Bar Chart - Top provinsi by views</li>
              <li>📋 Tabel breakdown provinsi & kategori</li>
            </ul>
          </div>
        </div>

        <div style={{background:'linear-gradient(to bottom right, #f0fdf4, #dcfce7)',borderRadius:'1rem',padding:'1.5rem',border:'1px solid #86efac',marginBottom:'2rem'}}>
          <h3 style={{fontWeight:'600',color:'#14532d',marginBottom:'0.75rem'}}>🤖 AI-Powered Insights</h3>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(150px, 1fr))',gap:'1rem',fontSize:'0.875rem'}}>
            <div style={{background:'rgba(255,255,255,0.6)',borderRadius:'0.75rem',padding:'1rem'}}>
              <p style={{fontWeight:'500',color:'#166534',marginBottom:'0.25rem'}}>Ringkasan Eksekutif</p>
              <p style={{color:'#15803d',fontSize:'0.75rem'}}>Analisis otomatis performa bulan ini</p>
            </div>
            <div style={{background:'rgba(255,255,255,0.6)',borderRadius:'0.75rem',padding:'1rem'}}>
              <p style={{fontWeight:'500',color:'#166534',marginBottom:'0.25rem'}}>Analisis Data</p>
              <p style={{color:'#15803d',fontSize:'0.75rem'}}>Insight distribusi konten & trend</p>
            </div>
            <div style={{background:'rgba(255,255,255,0.6)',borderRadius:'0.75rem',padding:'1rem'}}>
              <p style={{fontWeight:'500',color:'#166534',marginBottom:'0.25rem'}}>Rekomendasi Strategis</p>
              <p style={{color:'#15803d',fontSize:'0.75rem'}}>Saran pengembangan konten</p>
            </div>
          </div>
        </div>

        <div style={{background:'#fffbeb',border:'1px solid #fcd34d',borderRadius:'1rem',padding:'1.5rem'}}>
          <h3 style={{fontWeight:'600',color:'#92400e',marginBottom:'0.5rem'}}>💡 Info Penting</h3>
          <p style={{fontSize:'0.875rem',color:'#b45309'}}>
            Laporan menggunakan <strong>OpenAI GPT-4o-mini</strong> untuk generate narasi analisis dan rekomendasi.
            PDF berisi <strong>9 halaman</strong> dengan watermark logo Kemenpar.
            Proses generate memerlukan waktu <strong>10-20 detik</strong>.
          </p>
        </div>
      </main>

      <footer style={{borderTop:'1px solid #e2e8f0',background:'white',marginTop:'2.5rem'}}>
        <div style={{maxWidth:'56rem',margin:'0 auto',padding:'1.5rem',textAlign:'center',fontSize:'0.875rem',color:'#64748b'}}>
          © 2026 Wonderful Images — Kementerian Pariwisata dan Ekonomi Kreatif RI
        </div>
      </footer>
    </div>
  );
}

export default function LaporanPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem("laporan_auth") === "true";
  });

  if (!isLoggedIn) {
    return <LaporanLogin onLogin={setIsLoggedIn} />;
  }

  return <LaporanDashboard onLogout={() => setIsLoggedIn(false)} />;
}
